const scrollableContainer = document.querySelector( '[data-scrollable-container]' );
const scrollIndicator = document.querySelector( '[data-scroll-indicator]');
const graphicContainers = document.querySelectorAll( '.hero-scroll-panel' );

const calculateScroll = () => {
	const scrollWidth = scrollableContainer.scrollWidth - scrollableContainer.clientWidth;
	const percentScroll = scrollableContainer.scrollLeft / scrollWidth * 100;
	const addition = percentScroll * 0.02;
	scrollIndicator.style.left = `calc(${percentScroll}% - ${addition}rem)`;
};

const inViewport = ( element ) => {
	const scrollWidth = scrollableContainer.scrollWidth - scrollableContainer.clientWidth;
	const left = scrollableContainer.scrollLeft;
	const container = element.querySelector( '.graphic' );
	const spacer = document.querySelector( '.spacer' );
	const spacerWidth = spacer.getBoundingClientRect().width;
	const leftAdjusted = left + spacerWidth;
	const notes = element.querySelector( '.notes' );
	notes.style.transition = 'all 1000ms ease-in-out';
	container.style.transition = 'all 500ms ease-in-out';

	if ( element.getBoundingClientRect().left <= leftAdjusted
		&& element.getBoundingClientRect().right < scrollWidth
		&& element.getBoundingClientRect().left > 0 ) {
			container.style.opacity = 1;
			container.classList.add( 'pulse' );
			notes.style.opacity = 1;
			notes.style.transform = 'translateY(-15px)';
	} else if ( element.getBoundingClientRect().left <= leftAdjusted
		&& element.getBoundingClientRect().right < scrollWidth
		&& window.innerWidth < 640 ) {
			container.style.opacity = 1;
			container.classList.add( 'pulse' );
			notes.style.opacity = 1;
			notes.style.transform = 'translateY(-15px)';
	} else {
		container.style.opacity = 0.25;
		container.classList.remove( 'pulse' );
		notes.style.opacity = 0;
		notes.style.transform = 'translateY(15px)';
	}
}

const detectGraphicVisibility = () => {
	graphicContainers.forEach( container => {
		inViewport( container );
	});
}

if ( scrollableContainer ) {
	scrollableContainer.addEventListener( 'scroll', calculateScroll );
	window.addEventListener( 'resize', calculateScroll );
	window.addEventListener( 'DOMContentLoaded', calculateScroll );
	scrollableContainer.addEventListener( 'scroll', detectGraphicVisibility );
	window.addEventListener( 'resize', detectGraphicVisibility );
	window.addEventListener( 'DOMContentLoaded', detectGraphicVisibility );
}



